module.exports = __webpack_public_path__ + "static/media/5DPO5.1c31f8d4.jpg";